import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtilStore {
  private _splashLoading = signal(false);
  private _splashError = signal(false);

  readonly isLoading = this._splashLoading.asReadonly();
  readonly loadingFailed = this._splashError.asReadonly();

  setLoadingStarted(): void {
    this._splashLoading.set(true);
    this._splashError.set(false);
  }

  setLoadingFinished(error = false): void {
    this._splashLoading.set(false);
    this._splashError.set(error);
  }

  resetState(): void {
    this._splashLoading.set(false);
    this._splashError.set(false);
  }
}
